import PropTypes from "prop-types";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { buildExcludeRuleKey } from "./subscriptionRulesExclude";

const RuleMultiSelectWithExclude = ({
  paramIndex,
  ruleName,
  excludeLabel,
  excludeFlags,
  setExcludeFlags,
  allOptionValues,
  allOptionValuesRef,
  children,
  ...selectProps
}) => {
  const flagKey = buildExcludeRuleKey(paramIndex, ruleName);
  const canExclude = Array.isArray(allOptionValues) && allOptionValues.length > 0;

  if (canExclude && allOptionValuesRef) {
    allOptionValuesRef.current[flagKey] = allOptionValues;
  }

  if (!canExclude) {
    return children || <Select {...selectProps} />;
  }

  return (
    <div className="d-flex align--start gap-16">
      <div className="flex--grow-1">
        {children || <Select {...selectProps} />}
      </div>
      <Input
        type="checkbox"
        label={excludeLabel}
        checked={!!excludeFlags[flagKey]}
        onChange={(checked) =>
          setExcludeFlags((previousFlags) => ({
            ...previousFlags,
            [flagKey]: checked,
          }))
        }
      />
    </div>
  );
};

RuleMultiSelectWithExclude.propTypes = {
  paramIndex: PropTypes.number.isRequired,
  ruleName: PropTypes.string.isRequired,
  excludeLabel: PropTypes.string.isRequired,
  excludeFlags: PropTypes.object.isRequired,
  setExcludeFlags: PropTypes.func.isRequired,
  allOptionValues: PropTypes.array,
  allOptionValuesRef: PropTypes.object,
  children: PropTypes.node,
};

RuleMultiSelectWithExclude.defaultProps = {
  allOptionValues: null,
  allOptionValuesRef: null,
  children: null,
};

export default RuleMultiSelectWithExclude;
